import { render, staticRenderFns } from "./IconCalendarV52.vue?vue&type=template&id=014565bc"
import script from "./IconCalendarV52.vue?vue&type=script&lang=js"
export * from "./IconCalendarV52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports